import type { ReactNode } from 'react';
import { CoreProviders } from './CoreProviders';
import { FeatureProviders } from './FeatureProviders';
import { DevelopmentProviders } from './DevelopmentProviders';

type AppProvidersProps = {
  readonly children: ReactNode;
};

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <CoreProviders>
      <FeatureProviders>
        <DevelopmentProviders>{children}</DevelopmentProviders>
      </FeatureProviders>
    </CoreProviders>
  );
}
